module.exports = __webpack_public_path__ + "static/media/JBTCB-BNB.7861e9ac.svg";